import { render, staticRenderFns } from "./task.vue?vue&type=template&id=1b6d298e"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=1b6d298e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports